/** SAR amounts of the register, as the mitigation plan quotes them. Riyals read as whole numbers. */
export function sar(amount: number, perYear = false): string {
  return `SAR ${Math.round(amount).toLocaleString()}${perYear ? "/yr" : ""}`;
}

/** Restoration times reach the register with the full precision of their computation. */
export function days(value: number | null): string | null {
  return value === null ? null : `${Math.round(value * 10) / 10} days`;
}

/** Capacities are summed from per-unit values, so they carry float noise; megawatts read as whole numbers. */
export function mw(value: number | null | undefined): string | null {
  return value === null || value === undefined
    ? null
    : Math.round(value).toLocaleString();
}

/** A risk reads as its category and the score behind it, "High - 64". */
export function riskValue(category: string | null, score: number | null) {
  if (category === null) {
    return null;
  }
  return score === null ? category : `${category} - ${score}`;
}
